if (!customElements.get('envelope-insights')) {
  customElements.define(
    'envelope-insights',
    class EnvelopeInsights extends HTMLElement {
      constructor() {
        super();
        this.activeLetter = null;
      }
      connectedCallback() {
        const sectionRoot = this.closest('section');
        const toolbar = this.querySelector('.insights__toolbar');
        const underlay = this.querySelector('.popup-underlay');
        const readMoreBtn = this.querySelector('[data-read-more]');
        const readmoreWrap = this.querySelector('.insights__readmore');
        const popupTriggers = this.querySelectorAll('[data-popup-trigger]');
        const popupClose = this.querySelectorAll('[data-popup-close]');
        const scrollOffset = 70; // Adjust if you have sticky header

        const clampTo = (px) => {
          if (!sectionRoot) return;
          sectionRoot.style.setProperty('--section-max-height', `${Math.ceil(px)}px`);
          readmoreWrap?.classList.remove('active');
          readMoreBtn?.classList.remove('hidden', 'is-expanded', 'no-margin');
        };

        const unclampAll = () => {
          readmoreWrap?.classList.add('active');
          readMoreBtn?.classList.add('hidden', 'is-expanded', 'no-margin');
        };

        const heightUntilBlock = (target) => {
          if (!readmoreWrap || !target) return null;
          const wrapTop = readmoreWrap.getBoundingClientRect().top + window.scrollY;
          const targetBottom = target.getBoundingClientRect().bottom + window.scrollY;
          return (targetBottom - wrapTop) + 8;
        };

        const scrollToElement = (element, offset = 0) => {
          if (!element) return;
          const rect = element.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const targetY = rect.top + scrollTop - offset;
          window.scrollTo({ top: targetY, behavior: 'smooth' });
        };

        const ensureFirstActive = () => {
          const firstReal = toolbar?.querySelector('[data-letter]:not(.empty-letter)');
          if (firstReal && !toolbar.querySelector('.active')) {
            firstReal.classList.add('active');
            this.activeLetter = firstReal.dataset.letter;
          }
        };

        if (toolbar) {
          const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
          const existingLetters = Array.from(toolbar.querySelectorAll('[data-letter]'))
            .map(el => el.dataset.letter?.toUpperCase());

          alphabet.forEach(letter => {
            if (!existingLetters.includes(letter)) {
              const span = document.createElement('span');
              span.textContent = letter;
              span.classList.add('empty-letter');
              let inserted = false;
              for (let i = 0; i < toolbar.children.length; i++) {
                const current = toolbar.children[i];
                const currentLetter = current.dataset.letter
                  ? current.dataset.letter.toUpperCase()
                  : current.textContent.trim().toUpperCase();
                if (currentLetter > letter) {
                  toolbar.insertBefore(span, current);
                  inserted = true;
                  break;
                }
              }
              if (!inserted) toolbar.appendChild(span);
            }
          });
          ensureFirstActive();
        }

        this.querySelectorAll('[data-letter]').forEach(link => {
          link.addEventListener('click', () => {
            if (link.classList.contains('empty-letter')) return;

            const letter = link.dataset.letter;
            const target = this.querySelector(`[data-block-letter="${letter}"]`);
            if (!target) return;

            toolbar.querySelectorAll('[data-letter]').forEach(l => l.classList.remove('active'));
            link.classList.add('active');
            this.activeLetter = letter;

            const nonEmptyLetters = Array.from(
              toolbar.querySelectorAll('[data-letter]:not(.empty-letter)')
            ).map(el => el.dataset.letter);

            const isLastLetter = letter === nonEmptyLetters[nonEmptyLetters.length - 1];

            if (isLastLetter) {
              unclampAll();
              requestAnimationFrame(() => {
                setTimeout(() => {
                  scrollToElement(target, scrollOffset);
                }, 250);
              });
              return;
            }

            const h = heightUntilBlock(target);
            if (h != null) clampTo(h);

            requestAnimationFrame(() => {
              setTimeout(() => {
                scrollToElement(target, scrollOffset);
              }, 220);
            });

            if (readMoreBtn) readMoreBtn.classList.remove('mt-10');
          });
        });

        if (readMoreBtn) {
          readMoreBtn.addEventListener('click', () => {
            unclampAll();
            // reduce margin after expanded
            setTimeout(() => readMoreBtn?.classList.add('no-margin'), 100);
          });
        }

        const recalcOnResize = () => {
          if (!this.activeLetter) return;
          const target = this.querySelector(`[data-block-letter="${this.activeLetter}"]`);
          if (!target) return;
          if (!readmoreWrap?.classList.contains('active')) {
            const h = heightUntilBlock(target);
            if (h != null) clampTo(h);
          }
        };
        window.addEventListener('resize', this._resizeHandler = () => {
          clearTimeout(this._rszT);
          this._rszT = setTimeout(recalcOnResize, 150);
        });

        popupTriggers.forEach(trigger => {
          trigger.addEventListener('click', () => {
            underlay?.classList.add('active');
            trigger.parentElement.nextElementSibling.classList.add('active');
          });
        });

        underlay?.addEventListener('click', () => {
          this.querySelector('.insight__card-popup.active')?.classList.remove('active');
          underlay.classList.remove('active');
        });

        popupClose.forEach(close => {
          close.addEventListener('click', () => {
            this.querySelector('.insight__card-popup.active')?.classList.remove('active');
            underlay?.classList.remove('active');
          });
        });
      }

      disconnectedCallback() {
        if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler);
      }
    }
  );
}
